import React from 'react';
import { useTranslation } from 'react-i18next';

import ContentLangButton from 'src/components/common/ContentLangBtn';
import { useMassActionState } from 'src/components/massAction/MassActionStateContext';

const CtnLangComponent = props => {
  const { t } = useTranslation();
  const [{ currentCampaignAction }, setMassActionState] = useMassActionState();
  const currentLang = currentCampaignAction?.language ?? null;

  const onContentLangChange = newLang =>
    setMassActionState(state => ({
      ...state,
      currentCampaignAction: { ...state.currentCampaignAction, language: newLang },
      contentHasChanges: true,
    }));
  const onContentLangchange = value => {
    onContentLangChange(value);
    setMassActionState(state => ({
      ...state,
      currentCampaignAction: { ...state.currentCampaignAction, language: value },
      contentHasChanges: true,
    }));
  };
  return (
    <ContentLangButton
      {...props}
      currentLang={currentLang}
      onContentLangChange={onContentLangchange}
      title={t('smartmessaging.tooltip.contentLangButton')}
    />
  );
};

export default CtnLangComponent;
